(function () {
  var NAV_URL_ALIASES = {
    "/collections/pre-treated-laces": "/collections/pre-treated-laces-1",
    "/collections/sneaker-freshener": "/collections/sneaker-fresheners",
    "/collections/sneaker-conditioner": "/collections/sneaker-conditioners",
    "/collections/towels": "/products/crep-protect-cleaning-towel-ean",
    "/collections/sneaker-protectors": "/products/crep-protect-sneaker-guards-2-ean",
    "/collections/black-friday": "/collections/black-friday-buy-1-get-1-free",
    "/collections/black-friday-sale": "/collections/black-friday-buy-1-get-1-free",
    "/collections/vinyl-footwear-protection-cleaning": "/collections/products-to-protect-your-sneakers-footwear",
    "/collections/leather-footwear-protection-cleaning": "/collections/sneaker-conditioners",
    "/collections/suede-nubuck-footwear-protection-cleaning": "/collections/suede-nubuck-care",
    "/collections/premium-exotic-footwear-protection-cleaning": "/collections/protection",
    "/collections/mixed-material-footwear-protection-cleaning": "/collections/cleaning",
    "/collections/canvas-footwear-protection-cleaning": "/collections/cleaning",
    "/products/foam-mini": "/products/crep-protect-foam-mini-ean",
    "/products/towel": "/products/crep-protect-cleaning-towel-ean",
    "/products/power": "/products/crep-protect-power-tool-shoe-cleaner-ean",
    "/products/crep-protect-spray": "/products/crep-protect-spray-ean",
    "/products/crep-protect-crate-v3": "/products/crep-protect-sneaker-crates-v3-ean",
    "/products/crate-2-0-2-crates": "/products/crep-protect-shoe-storage-display-crate-v2-ean",
    "/products/crep-protect-sneaker-bag": "/products/crep-protect-sneaker-bag-upc",
    "/products/crep-protect-pre-treated-laces": "/products/crep-protect-pre-treated-shoe-laces-ean",
    "/products/Laces-colour-allblack-flat-v2": "/products/crep-protect-pre-treated-shoe-laces-ean",
    "/products/crep-protect-comfort-insoles": "/products/crep-protect-comfort-insoles-ean",
    "/products/insole-Comfort": "/products/crep-protect-comfort-insoles-ean",
    "/products/crep-protect-sneaker-guards-2-0": "/products/crep-protect-sneaker-guards-2-ean",
    "/collections/insoles/products/crep-protect-comfort-insoles": "/products/crep-protect-comfort-insoles-ean",
    "/products/bundle2": "/collections/bundles"
  };

  var FORCED_NAV_SELECTOR = ".cp-dnav__l3-panel a, .cp-dnav__left-feature, .cp-dnav__right-feature-card, .cp-dnav__daily-item, .cp-dnav__daily-cta";

  function isStandardLeftClick(event) {
    var button = typeof event.button == "number" ? event.button : 0;
    return button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  }

  function isNavigableHref(href) {
    if (!href) return false;
    var normalized = String(href).trim().toLowerCase();
    return normalized !== "" && normalized !== "#" && !normalized.startsWith("javascript:");
  }

  function normalizePathname(pathname) {
    if (!pathname) return "/";
    var normalized = pathname.replace(/\/+$/, "");
    return normalized === "" ? "/" : normalized;
  }

  function isCrepUsDomain(hostname) {
    if (!hostname) return false;
    var host = String(hostname).toLowerCase();
    return (host === "crepprotect.com" || host === "www.crepprotect.com") && host !== window.location.hostname.toLowerCase();
  }

  function remapNavHref(href) {
    if (!isNavigableHref(href)) return href;

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return href;
    }

    var normalizedPathname = normalizePathname(url.pathname);
    var mappedPathname = NAV_URL_ALIASES[normalizedPathname] || normalizedPathname;

    if (isCrepUsDomain(url.hostname)) {
      return window.location.origin + mappedPathname + url.search + url.hash;
    }

    if (url.origin !== window.location.origin) return url.toString();

    url.pathname = mappedPathname;
    return url.toString();
  }

  function normalizeHref(href) {
    if (!isNavigableHref(href)) return "";

    try {
      return new URL(href, window.location.origin).toString();
    } catch (error) {
      return "";
    }
  }

  function toRelativeHref(href) {
    if (!isNavigableHref(href)) return href;

    try {
      var url = new URL(href, window.location.origin);
      if (url.origin === window.location.origin) {
        return url.pathname + url.search + url.hash;
      }
      return url.toString();
    } catch (error) {
      return href;
    }
  }

  function rewriteLinkHref(link) {
    if (!link || !link.getAttribute) return;

    var hrefAttr = link.getAttribute("href") || link.href;
    if (!isNavigableHref(hrefAttr)) return;

    var normalizedHref = normalizeHref(hrefAttr);
    if (!normalizedHref) return;

    var mappedHref = remapNavHref(hrefAttr);
    var normalizedMappedHref = normalizeHref(mappedHref);
    if (!normalizedMappedHref || normalizedMappedHref === normalizedHref) return;

    link.setAttribute("data-cp-original-href", hrefAttr);
    link.setAttribute("href", toRelativeHref(mappedHref));
  }

  function rewriteLinksIn(root) {
    if (!root) return;

    if (root.nodeType === 1 && root.matches && root.matches("a[href]")) {
      rewriteLinkHref(root);
    }

    if (!root.querySelectorAll) return;
    root.querySelectorAll("a[href]").forEach(rewriteLinkHref);
  }

  function observeDynamicLinks() {
    if (!document.body || typeof MutationObserver !== "function") return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          rewriteLinksIn(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function bindGlobalMappedNavigationCapture() {
    if (window.__cpUkMappedNavigationBound) return;
    window.__cpUkMappedNavigationBound = true;

    function forceMappedNavigate(event) {
      var target = event.target && event.target.closest ? event.target.closest("a[href]") : null;
      if (!target) return;
      if (event.type === "pointerdown" && !isStandardLeftClick(event)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var hrefAttr = target.getAttribute("href") || target.href;
      if (!isNavigableHref(hrefAttr)) return;

      var normalizedHref = normalizeHref(hrefAttr);
      var mappedHref = remapNavHref(hrefAttr);
      var normalizedMappedHref = normalizeHref(mappedHref);

      if (!normalizedHref || !normalizedMappedHref || normalizedHref === normalizedMappedHref) return;

      target.setAttribute("data-cp-original-href", hrefAttr);
      target.setAttribute("href", toRelativeHref(mappedHref));

      if (target.target && target.target !== "_self") return;

      event.preventDefault();
      window.location.assign(mappedHref);
    }

    window.addEventListener("pointerdown", forceMappedNavigate, true);
    window.addEventListener("click", forceMappedNavigate, true);
  }

  function getForcedNavLink(target) {
    if (!target || !target.closest) return null;
    var link = target.closest(FORCED_NAV_SELECTOR);
    return link && link.closest(".cp-dnav") ? link : null;
  }

  function getNav(itemOrPanel) {
    return itemOrPanel ? itemOrPanel.closest(".cp-dnav") : null;
  }

  function closeAll(nav) {
    if (!nav) return;
    nav.querySelectorAll(".cp-dnav__item.cp-is-open").forEach(function (item) {
      item.classList.remove("cp-is-open");
    });
    nav.querySelectorAll(".cp-dnav__panel--mega").forEach(function (panel) {
      setActive(panel, "");
    });
  }

  function setActive(panel, groupName) {
    var triggers = panel.querySelectorAll("[data-group-trigger]");
    var level3Panels = panel.querySelectorAll("[data-group-panel]");
    var leftFeatureCards = panel.querySelectorAll("[data-left-feature-card]");
    var rightFeatureCards = panel.querySelectorAll("[data-right-feature-card]");
    var leftFeatureWrap = panel.querySelector(".cp-dnav__left-feature-wrap");
    var rightFeatureWrap = panel.querySelector(".cp-dnav__right-feature-wrap");
    var shell = panel.querySelector(".cp-dnav__shell");
    var secondary = panel.querySelector(".cp-dnav__secondary");
    var currentTrigger = panel.querySelector('[data-group-trigger="' + groupName + '"]');
    var hasChildren = currentTrigger && currentTrigger.getAttribute("data-has-children") === "true";
    var leftFeatureKey = (currentTrigger && currentTrigger.getAttribute("data-left-feature")) || "";
    var rightFeatureKey = (currentTrigger && currentTrigger.getAttribute("data-right-feature")) || "";

    triggers.forEach(function (trigger) {
      trigger.classList.toggle("is-active", trigger.getAttribute("data-group-trigger") === groupName);
    });

    level3Panels.forEach(function (level3) {
      var shouldShow = hasChildren && level3.getAttribute("data-group-panel") === groupName;
      level3.classList.toggle("is-active", shouldShow);
    });

    leftFeatureCards.forEach(function (feature) {
      feature.classList.toggle("is-active", leftFeatureKey !== "" && feature.getAttribute("data-left-feature-card") === leftFeatureKey);
    });

    rightFeatureCards.forEach(function (feature) {
      feature.classList.toggle("is-active", hasChildren && rightFeatureKey !== "" && feature.getAttribute("data-right-feature-card") === rightFeatureKey);
    });

    if (leftFeatureWrap) leftFeatureWrap.classList.toggle("is-visible", leftFeatureKey !== "");
    if (rightFeatureWrap) rightFeatureWrap.classList.toggle("is-hidden", !hasChildren || rightFeatureKey === "");
    if (shell) shell.classList.toggle("is-no-secondary", !hasChildren);
    if (secondary) secondary.classList.toggle("is-hidden", !hasChildren);
    if (panel.classList.contains("cp-dnav__panel--mega")) panel.classList.toggle("is-collapsed", !hasChildren);
  }

  function closePanel(item, panel) {
    item.classList.remove("cp-is-open");
    if (panel.classList.contains("cp-dnav__panel--mega")) setActive(panel, "");
  }

  function initMegaPanel(panel) {
    var triggers = panel.querySelectorAll("[data-group-trigger]");
    if (!triggers.length) return;

    setActive(panel, "");

    triggers.forEach(function (trigger) {
      var groupName = trigger.getAttribute("data-group-trigger");
      if (!groupName) return;
      trigger.addEventListener("mouseenter", function () {
        setActive(panel, groupName);
      });
      trigger.addEventListener("focus", function () {
        setActive(panel, groupName);
      });
    });

    var item = panel.closest(".cp-dnav__item");
    if (!item) return;

    item.addEventListener("mouseenter", function () {
      var nav = getNav(item);
      closeAll(nav);
      item.classList.add("cp-is-open");
      setActive(panel, "");
    });

    item.addEventListener("mouseleave", function () {
      closePanel(item, panel);
    });

    item.addEventListener("focusin", function () {
      var nav = getNav(item);
      closeAll(nav);
      item.classList.add("cp-is-open");
    });

    item.addEventListener("focusout", function (event) {
      var next = event.relatedTarget;
      if (!next || !item.contains(next)) closePanel(item, panel);
    });

    panel.addEventListener("mouseleave", function () {
      closePanel(item, panel);
    });
  }

  function initSimplePanel(panel) {
    var item = panel.closest(".cp-dnav__item");
    if (!item) return;

    item.addEventListener("mouseenter", function () {
      var nav = getNav(item);
      closeAll(nav);
      item.classList.add("cp-is-open");
    });

    item.addEventListener("mouseleave", function () {
      closePanel(item, panel);
    });

    item.addEventListener("focusin", function () {
      var nav = getNav(item);
      closeAll(nav);
      item.classList.add("cp-is-open");
    });

    item.addEventListener("focusout", function (event) {
      var next = event.relatedTarget;
      if (!next || !item.contains(next)) closePanel(item, panel);
    });

    panel.addEventListener("mouseleave", function () {
      closePanel(item, panel);
    });
  }

  function bindForcedNavigationCapture() {
    if (window.__cpDnavForcedNavigationBound) return;
    window.__cpDnavForcedNavigationBound = true;

    function forceNavigate(event) {
      var link = getForcedNavLink(event.target);
      if (!link) return;
      if (event.type === "pointerdown" && !isStandardLeftClick(event)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var hrefAttr = link.getAttribute("href") || link.href;
      if (!isNavigableHref(hrefAttr)) return;

      var targetHref = remapNavHref(hrefAttr);
      if (!isNavigableHref(targetHref)) return;

      var nav = getNav(link);
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      closeAll(nav);
      window.location.assign(targetHref);
    }

    window.addEventListener("pointerdown", forceNavigate, true);
    window.addEventListener("click", forceNavigate, true);
  }

  function init() {
    rewriteLinksIn(document);
    observeDynamicLinks();
    bindGlobalMappedNavigationCapture();
    bindForcedNavigationCapture();

    var nav = document.querySelector(".cp-dnav");
    if (!nav) return;

    closeAll(nav);
    nav.querySelectorAll(".cp-dnav__item.is-open").forEach(function (item) {
      item.classList.remove("is-open");
    });
    nav.querySelectorAll(".cp-dnav__panel--mega").forEach(initMegaPanel);
    nav.querySelectorAll(".cp-dnav__panel:not(.cp-dnav__panel--mega)").forEach(initSimplePanel);
    nav.addEventListener("mouseleave", function () {
      closeAll(nav);
    });
    document.addEventListener("pointermove", function (event) {
      if (!nav.contains(event.target)) closeAll(nav);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeAll(nav);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
//# sourceMappingURL=/s/files/1/0631/6644/7787/t/51/assets/cp-desktop-polaroid-nav.js.map?v=1775130832
